import React from "react";
import styles from "./ContentDisplay.module.scss";
import { buildHeaders, generateUrlApiV2 } from "../../util/helpers/MiddlewareHelpers";

const TIMER_KEY = "content_display_timer_end";

export default class ContentDisplay extends React.Component {
  constructor(props) {
    super(props);
    // Accept parameter via props.param (reasonable default)
    this.param = (this.props && this.props.match && this.props.match.params
      && this.props.match.params.param) ? this.props.match.params.param : "";
    this.state = {
      loading: true,
      error: null,
      data: null,
      remainingSeconds: 0,
    };
    this.tickInterval = null;
  }

  componentDidMount() {
    this.startOrRestoreTimer(5 * 60); // 5 minutes default
    this.fetchData(this.param);
  }

  componentWillUnmount() {
    if (this.tickInterval) clearInterval(this.tickInterval);
  }

  startOrRestoreTimer(defaultSeconds) {
    // Check localStorage for stored end timestamp
    try {
      const stored = localStorage.getItem(TIMER_KEY);
      let endTs;
      if (stored) {
        endTs = parseInt(stored, 10);
      } else {
        endTs = Date.now() + defaultSeconds * 1000;
        localStorage.setItem(TIMER_KEY, String(endTs));
      }
      this.updateRemaining(endTs);
      this.tickInterval = setInterval(() => this.updateRemaining(endTs), 500);
    } catch (err) {
      // localStorage unavailable -> fallback to in-memory
      const endTs = Date.now() + defaultSeconds * 1000;
      this.updateRemaining(endTs);
      this.tickInterval = setInterval(() => this.updateRemaining(endTs), 500);
    }
  }

  updateRemaining(endTs) {
    const now = Date.now();
    const diff = Math.max(0, Math.round((endTs - now) / 1000));
    this.setState({ remainingSeconds: diff });
    if (diff <= 0) {
      // clear stored timer so next mount restarts
      try {
        localStorage.removeItem(TIMER_KEY);
      } catch (e) {}
      if (this.tickInterval) {
        clearInterval(this.tickInterval);
        this.tickInterval = null;
      }
    }
  }

  async fetchData(param) {
    this.setState({ loading: true, error: null });
    try {

      const headers = buildHeaders();
      const url = generateUrlApiV2(`/competition/getRandData`);

      const res = await fetch(url, {
        method: "POST",
        crossdomain: true,
        headers,
        body: JSON.stringify({ uuid: param }),
      });
      if (!res.ok) throw new Error(`API error ${res.status}`);
      const json = await res.json();
      // Expecting shape: { logo, title, description, image, items: [{logo, text}, ...] }
      this.setState({ data: json, loading: false });
    } catch (err) {
      this.setState({ error: err.message || "Fetch error", loading: false });
    }
  }

  formatTime(seconds) {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  }

  renderCentered() {
    const { data } = this.state;
    if (!data) return null;
    return (
      <div className={styles.centerBox}>
        {data.logo && (
          <img src={data.logo} alt="logo" className={styles.centerLogo} />
        )}
        {data.title && <h1 className={styles.title}>{data.title}</h1>}
        {data.description && (
          <p className={styles.description}>{data.description}</p>
        )}
        {data.image && (
          <img src={data.image} alt="main" className={styles.centerImage} />
        )}
      </div>
    );
  }

  renderList() {
    const items = (this.state.data && this.state.data.items) || [];
    return (
      <div className={styles.list}>
        {items.map((it, idx) => (
          <div className={styles.listItem} key={idx}>
            {it.logo && (
              <img src={it.logo} alt="" className={styles.itemLogo} />
            )}
            <div className={styles.itemText}>{it.text}</div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { loading, error, remainingSeconds } = this.state;
    return (
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.timer}>
            <span className={styles.timerLabel}>Time left</span>
            <span className={styles.timerValue}>
              {this.formatTime(remainingSeconds)}
            </span>
          </div>
        </header>

        <main className={styles.main}>
          {loading && <div className={styles.message}>Loading…</div>}
          {error && <div className={styles.error}>Error: {error}</div>}
          {!loading && !error && (
            <>
              {this.renderCentered()}
              {this.renderList()}
            </>
          )}
        </main>
      </div>
    );
  }
}
